module.exports = __webpack_public_path__ + "static/media/under_evaluation.239c162c.svg";